module.exports = __webpack_public_path__ + "media/kinetic.85f22112.mp4";